import { GREYSCOUT_COMPANY_ID } from '@/resources/constants';
import { useUser } from '@/hooks/companyUser/useUser';
import { useAuthentication } from '@/hooks/user/useAuthentication';

/**
 * Whether the signed-in user belongs to Grey Scout, alongside whether that is still being
 * resolved. Membership comes from a fetched user record, so a guard that redirects on `false`
 * needs `isLoading` to avoid turning away a real employee mid-request.
 */
export const useGreyScoutEmployeeAccess = () => {
  const {
    user: authUser,
  } = useAuthentication();

  const userId = authUser?.gsUid;

  const {
    user,
    isLoading,
  } = useUser(userId ? String(userId) : undefined);

  const companyId = user?.linked?.company?.id;

  return {
    isGreyScoutEmployee: companyId === GREYSCOUT_COMPANY_ID,
    isLoading,
  };
};

export const useIsGreyScoutEmployee = () => useGreyScoutEmployeeAccess().isGreyScoutEmployee;
